import MDIGITAL_INIT from "./MDIGITAL_INIT";
import GLOBALS from "./GLOBALS";

MDIGITAL_INIT.init();
GLOBALS.init();
